class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.elements = {
      sidebarDrawer: this.querySelector('.menu-drawer'),
      overlay: document.querySelector('body > .overlay'),
      sidebarDrawerButton: this.querySelectorAll('.button-close'),
      shopifySection: this.closest('.shopify-section')
    };
    if (!this.elements.sidebarDrawer) return;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    const drawer = this.elements.sidebarDrawer;
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    if (!drawer.hasAttribute('aria-label')) {
      drawer.setAttribute('aria-label', document.querySelector(`[aria-controls="${drawer.id}"]`)?.closest('nav')?.getAttribute('aria-label') || document.querySelector('.burger-menu')?.getAttribute('aria-label') || 'Menu');
    }
    drawer.setAttribute('tabindex', '-1');
    this.setExpanded(!drawer.hidden);
    // Delegation also handles triggers replaced by the Shopify theme editor.
    document.addEventListener('click', event => {
      const trigger = event.target.closest('.burger-menu');
      if (!trigger || (trigger.getAttribute('aria-controls') && trigger.getAttribute('aria-controls') !== drawer.id)) return;
      this.openDrawer(event);
    }, options);
    this.elements.sidebarDrawerButton.forEach(button => button.addEventListener('click', () => this.closeDrawer(), options));
    document.addEventListener('keyup', event => {
      if (event.code?.toUpperCase() === 'ESCAPE' && !drawer.hidden) this.closeDrawer();
    }, options);
    this.elements.overlay?.addEventListener('click', () => this.closeDrawer(), options);
    window.addEventListener('resize', () => this.offsetHeight(), options);
    if (window.Shopify?.designMode && this.elements.shopifySection) {
      this.elements.shopifySection.addEventListener('shopify:section:select', () => this.openDrawer(), options);
      this.elements.shopifySection.addEventListener('shopify:section:deselect', () => this.closeDrawer(), options);
    }
  }

  setExpanded(expanded) {
    document.querySelectorAll('.burger-menu').forEach(trigger => {
      trigger.setAttribute('aria-controls', this.elements.sidebarDrawer.id);
      trigger.setAttribute('aria-expanded', String(expanded));
    });
  }

  openDrawer(event) {
    const drawer = this.elements.sidebarDrawer;
    if (!drawer.hidden) return;
    this.opener = event?.target?.closest('.burger-menu') || document.activeElement;
    drawer.removeAttribute('hidden');
    this.setExpanded(true);
    document.body.classList.add('hidden');
    if (drawer.id === 'mega-menu-drawer') this.elements.overlay?.classList.add('open');
    this.offsetHeight();
    this.openTimer = setTimeout(() => {
      drawer.classList.add('open');
      const first = drawer.querySelector('.button-close') || drawer.querySelector('a[href], button:enabled, summary') || drawer;
      if (typeof trapFocus === 'function') trapFocus(drawer, first);
      else first.focus();
    }, 100);
  }

  offsetHeight() {
    const pinned = this.querySelector('.pinned-block');
    if (pinned && this.querySelector('.nested-submenu')) {
      this.elements.sidebarDrawer.style.setProperty('--height-pinned-block', `${pinned.offsetHeight + 16}px`);
    }
  }

  closeDrawer() {
    const drawer = this.elements?.sidebarDrawer;
    if (!drawer || drawer.hidden) return;
    clearTimeout(this.openTimer);
    drawer.setAttribute('hidden', 'true');
    drawer.classList.remove('open');
    this.setExpanded(false);
    if (drawer.id === 'mega-menu-drawer') this.elements.overlay?.classList.remove('open');
    document.body.classList.remove('hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.opener?.isConnected ? this.opener : null);
    else if (this.opener?.isConnected) this.opener.focus();
    document.dispatchEvent(new CustomEvent('body:visible'));
  }

  disconnectedCallback() {
    this.closeDrawer();
    this.abort?.abort();
    clearTimeout(this.openTimer);
  }
}
customElements.define('menu-drawer', MenuDrawer);
